import { useMediaQuery } from 'react-responsive';
import { QUERIES } from './Consts';

export const useResponsive = () => {
	return {
		isMobile: useMediaQuery(QUERIES.mobile),
		isTablet: useMediaQuery(QUERIES.tablet),
		isDesktop: useMediaQuery(QUERIES.desktop),
	};
};